import COMPONENT_MAP from '../Repository/Components.js';

//New/edit time entry - also opened by the "Sick" button with presetCategory=SICK_LEAVE
const WorkTimeEntryPopup=({popupCallBack,rowId,parent,userData,application,presetCategory=null})=>{

    const pageCallback=async(action,args)=>{
        popupCallBack(action,args);
    }

    const context=['parent_field_name='+parent.parent_field_name,'parent_field_value='+parent.parent_field_value,'parent_name='+parent.parent_name];
    if(presetCategory){
        context.push('preset_category='+presetCategory);
    }

    const titleLabel=presetCategory==='SICK_LEAVE'?'PopupSickLeave':(rowId?'PopupWorkTimeEntry':'PopupNewWorkTimeEntry');

    const renderPageDetail=()=>{
        const Component=COMPONENT_MAP['PageDetail'];
        return Component?(
            <Component
                recordId={rowId}
                userData={userData}
                application={application}
                entityType={'WorkTimeEntry'}
                entityParams={['_context='+context,'_lang='+application.globalData.lang]}
                file={'WorkTimeEntryPopup.js'}
                titleLabel={application?.getLocale(titleLabel)}
                pageCallback={pageCallback}
                pageTabs={[]}
                isPopUp={true}
            />
        ):null;
    };
    return (renderPageDetail());
}

export default WorkTimeEntryPopup;
